export const PDF_CMF_KEY = 'PDF_CMF'
